// src/data/templates.ts
import type { StartupTemplate } from '../components/StartupContext';

export const STARTUP_TEMPLATES: StartupTemplate[] = [
  {
    id: 'saas-b2b',
    name: 'B2B SaaS Platform',
    industry: 'SaaS',
    description: 'Enterprise software platform for businesses',
    icon: 'Building2',
    teamRoles: [
       { id: 'ceo', name: 'CEO', salary: 180000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'cto', name: 'CTO', salary: 160000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'senior-eng', name: 'Senior Engineer', salary: 140000, headcount: [0,1,2,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12], category: 'engineering' },
       { id: 'product-manager', name: 'Product Manager', salary: 120000, headcount: [0,0,1,1,1,2,2,2,2,3,3,3,3,3,4,4,4,4,4,4,5,5], category: 'operations' },
       { id: 'designer', name: 'UX Designer', salary: 100000, headcount: [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'design' },
       { id: 'sales', name: 'Sales Manager', salary: 110000, headcount: [0,0,0,0,1,1,1,1,2,2,2,2,2,2,3,3,3,3,3,3,4,4], category: 'sales' },
    ],
    operatingCosts: [
       { id: 'aws', name: 'AWS Infrastructure', monthlyCosts: [2000,2500,3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500], category: 'infrastructure' },
       { id: 'office', name: 'Office Space', monthlyCosts: [0,0,2000,2000,3000,3000,4000,4000,5000,5000,6000,6000,7000,7000,8000,8000,9000,9000,10000,10000,11000,11000], category: 'facilities' },
       { id: 'tools', name: 'Development Tools', monthlyCosts: [500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600], category: 'tools' },
       { id: 'marketing', name: 'Marketing & Sales', monthlyCosts: [1000,1500,2000,2500,3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500], category: 'marketing' },
    ],
    companyProfile: {
      name: 'TechCorp',
      industry: 'SaaS',
      location: 'San Francisco, CA',
      companySize: 'small',
      salaryMultiplier: 1.2,
    },
    assumptions: {
      initialUsers: 50,
      monthlyGrowthRate: 15,
      revenueMultiple: 8,
      soloGrowthRate: 10,
      teamGrowthRate: 12,
      unlimitedGrowthRate: 15,
      enableExpenseGrowth: true,
      expenseGrowthRate: 10,
      expenseGrowthCap: 50,
    },
    pricing: {
      soloPrice: 29,
      teamPrice: 99,
      unlimitedPrice: 299,
    },
  },
  {
    id: 'ecommerce-platform',
    name: 'E-commerce Platform',
    industry: 'E-commerce',
    description: 'Online marketplace for retail businesses',
    icon: 'ShoppingCart',
    teamRoles: [
       { id: 'ceo', name: 'CEO', salary: 150000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'cto', name: 'CTO', salary: 140000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'backend-eng', name: 'Backend Engineer', salary: 120000, headcount: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22], category: 'engineering' },
       { id: 'frontend-eng', name: 'Frontend Engineer', salary: 110000, headcount: [1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11], category: 'engineering' },
       { id: 'product-manager', name: 'Product Manager', salary: 115000, headcount: [0,1,1,1,2,2,2,3,3,3,4,4,4,5,5,5,6,6,6,6,7,7], category: 'operations' },
       { id: 'designer', name: 'UI/UX Designer', salary: 95000, headcount: [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'design' },
       { id: 'customer-success', name: 'Customer Success Manager', salary: 85000, headcount: [0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10], category: 'support' },
    ],
    operatingCosts: [
       { id: 'servers', name: 'Server Infrastructure', monthlyCosts: [3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500,13000,13500], category: 'infrastructure' },
       { id: 'payment-processing', name: 'Payment Processing Fees', monthlyCosts: [500,750,1000,1250,1500,1750,2000,2250,2500,2750,3000,3250,3500,3750,4000,4250,4500,4750,5000,5250,5500,5750], category: 'other' },
       { id: 'warehouse', name: 'Warehouse & Logistics', monthlyCosts: [2000,2500,3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500], category: 'facilities' },
       { id: 'marketing', name: 'Digital Marketing', monthlyCosts: [2000,2500,3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500], category: 'marketing' },
       { id: 'tools', name: 'E-commerce Tools', monthlyCosts: [800,900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600,2700,2800,2900], category: 'tools' },
    ],
    companyProfile: {
      name: 'ShopFlow',
      industry: 'E-commerce',
      location: 'New York, NY',
      companySize: 'medium',
      salaryMultiplier: 1.1,
    },
    assumptions: {
      initialUsers: 100,
      monthlyGrowthRate: 20,
      revenueMultiple: 6,
      soloGrowthRate: 15,
      teamGrowthRate: 18,
      unlimitedGrowthRate: 20,
      enableExpenseGrowth: true,
      expenseGrowthRate: 12,
      expenseGrowthCap: 60,
    },
    pricing: {
      soloPrice: 49,
      teamPrice: 149,
      unlimitedPrice: 499,
    },
  },
  {
    id: 'fintech-app',
    name: 'FinTech Mobile App',
    industry: 'FinTech',
    description: 'Digital banking and financial services app',
    icon: 'TrendingUp',
    teamRoles: [
       { id: 'ceo', name: 'CEO', salary: 200000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'cfo', name: 'CFO', salary: 170000, headcount: [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
       { id: 'cto', name: 'CTO', salary: 180000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'security-architect', name: 'Security Architect', salary: 160000, headcount: [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'mobile-dev', name: 'Mobile Developer', salary: 130000, headcount: [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23], category: 'engineering' },
       { id: 'compliance-officer', name: 'Compliance Officer', salary: 140000, headcount: [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
       { id: 'risk-manager', name: 'Risk Manager', salary: 135000, headcount: [0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
    ],
    operatingCosts: [
       { id: 'cloud-security', name: 'Secure Cloud Infrastructure', monthlyCosts: [5000,6000,7000,8000,9000,10000,11000,12000,13000,14000,15000,16000,17000,18000,19000,20000,21000,22000,23000,24000,25000,26000], category: 'infrastructure' },
       { id: 'compliance-tools', name: 'Compliance & Security Tools', monthlyCosts: [2000,2200,2400,2600,2800,3000,3200,3400,3600,3800,4000,4200,4400,4600,4800,5000,5200,5400,5600,5800,6000,6200], category: 'tools' },
       { id: 'banking-licenses', name: 'Banking Licenses & Fees', monthlyCosts: [10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000,10000], category: 'other' },
       { id: 'office-security', name: 'Secure Office Space', monthlyCosts: [3000,3000,4000,4000,5000,5000,6000,6000,7000,7000,8000,8000,9000,9000,10000,10000,11000,11000,12000,12000,13000,13000], category: 'facilities' },
       { id: 'insurance', name: 'Cyber Insurance', monthlyCosts: [1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500,1500], category: 'other' },
    ],
    companyProfile: {
      name: 'SecureBank',
      industry: 'FinTech',
      location: 'London, UK',
      companySize: 'medium',
      salaryMultiplier: 1.3,
    },
    assumptions: {
      initialUsers: 25,
      monthlyGrowthRate: 12,
      revenueMultiple: 10,
      soloGrowthRate: 8,
      teamGrowthRate: 10,
      unlimitedGrowthRate: 12,
      enableExpenseGrowth: true,
      expenseGrowthRate: 8,
      expenseGrowthCap: 40,
    },
    pricing: {
      soloPrice: 9.99,
      teamPrice: 29.99,
      unlimitedPrice: 99.99,
    },
  },
  {
    id: 'healthtech-platform',
    name: 'HealthTech Platform',
    industry: 'HealthTech',
    description: 'Healthcare management and telemedicine platform',
    icon: 'Heart',
    teamRoles: [
       { id: 'ceo', name: 'CEO', salary: 190000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'cmo', name: 'Chief Medical Officer', salary: 220000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
       { id: 'cto', name: 'CTO', salary: 175000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'hipaa-specialist', name: 'HIPAA Compliance Specialist', salary: 140000, headcount: [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
       { id: 'fullstack-dev', name: 'Full-Stack Developer', salary: 125000, headcount: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22], category: 'engineering' },
       { id: 'data-scientist', name: 'Data Scientist', salary: 135000, headcount: [0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10], category: 'engineering' },
       { id: 'patient-success', name: 'Patient Success Manager', salary: 95000, headcount: [0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,9,10,10], category: 'support' },
    ],
    operatingCosts: [
       { id: 'hipaa-compliant-cloud', name: 'HIPAA Compliant Cloud', monthlyCosts: [4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500,13000,13500,14000,14500], category: 'infrastructure' },
       { id: 'medical-devices', name: 'Medical Device Integration', monthlyCosts: [1500,1750,2000,2250,2500,2750,3000,3250,3500,3750,4000,4250,4500,4750,5000,5250,5500,5750,6000,6250,6500,6750], category: 'tools' },
       { id: 'telemedicine-licenses', name: 'Telemedicine Licenses', monthlyCosts: [2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000,2000], category: 'other' },
       { id: 'medical-insurance', name: 'Medical Malpractice Insurance', monthlyCosts: [2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500,2500], category: 'other' },
       { id: 'secure-office', name: 'PHI-Secure Office', monthlyCosts: [2500,2500,3500,3500,4500,4500,5500,5500,6500,6500,7500,7500,8500,8500,9500,9500,10500,10500,11500,11500,12500,12500], category: 'facilities' },
    ],
    companyProfile: {
      name: 'HealthConnect',
      industry: 'HealthTech',
      location: 'Boston, MA',
      companySize: 'medium',
      salaryMultiplier: 1.25,
    },
    assumptions: {
      initialUsers: 30,
      monthlyGrowthRate: 18,
      revenueMultiple: 9,
      soloGrowthRate: 12,
      teamGrowthRate: 15,
      unlimitedGrowthRate: 18,
      enableExpenseGrowth: true,
      expenseGrowthRate: 9,
      expenseGrowthCap: 45,
    },
    pricing: {
      soloPrice: 39,
      teamPrice: 129,
      unlimitedPrice: 399,
    },
  },
  {
    id: 'client-npd',
    name: 'Client NPD Services',
    industry: 'Consulting',
    description: 'New Product Development for clients - resource augmentation and lean product building',
    icon: 'Users',
    teamRoles: [
       { id: 'founder-ceo', name: 'Founder/CEO', salary: 120000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'lead-developer', name: 'Lead Developer', salary: 95000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'ux-designer', name: 'UX Designer', salary: 75000, headcount: [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'design' },
       { id: 'project-manager', name: 'Project Manager', salary: 70000, headcount: [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
       { id: 'business-analyst', name: 'Business Analyst', salary: 65000, headcount: [0,0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
    ],
    operatingCosts: [
       { id: 'cloud-dev', name: 'Cloud Development Environment', monthlyCosts: [800,900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600,2700,2800,2900], category: 'infrastructure' },
       { id: 'design-tools', name: 'Design & Prototyping Tools', monthlyCosts: [300,350,400,450,500,550,600,650,700,750,800,850,900,950,1000,1050,1100,1150,1200,1250,1300,1350], category: 'tools' },
       { id: 'client-meetings', name: 'Client Meeting & Travel', monthlyCosts: [500,600,700,800,900,1000,1100,1200,1300,1400,1500,1600,1700,1800,1900,2000,2100,2200,2300,2400,2500,2600], category: 'other' },
       { id: 'software-licenses', name: 'Development Software Licenses', monthlyCosts: [400,450,500,550,600,650,700,750,800,850,900,950,1000,1050,1100,1150,1200,1250,1300,1350,1400,1450], category: 'tools' },
    ],
    companyProfile: {
      name: 'NPD Solutions',
      industry: 'Consulting',
      location: 'Austin, TX',
      companySize: 'small',
      salaryMultiplier: 0.9,
    },
    assumptions: {
      initialUsers: 0, // Project-based, not subscription
      monthlyGrowthRate: 0,
      revenueMultiple: 3, // Lower multiple for service business
      soloGrowthRate: 0,
      teamGrowthRate: 0,
      unlimitedGrowthRate: 0,
      enableExpenseGrowth: true,
      expenseGrowthRate: 8,
      expenseGrowthCap: 40,
    },
    pricing: {
      soloPrice: 0, // Project-based pricing
      teamPrice: 0,
      unlimitedPrice: 0,
    },
  },
  {
    id: 'internal-product-lean',
    name: 'Internal Product (Lean Team)',
    industry: 'Product',
    description: 'Building an internal product with a lean team of 3-5 people',
    icon: 'Lightbulb',
    teamRoles: [
       { id: 'founder-product', name: 'Founder/Product Lead', salary: 100000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'founder' },
       { id: 'fullstack-dev', name: 'Full-Stack Developer', salary: 85000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'engineering' },
       { id: 'designer', name: 'Product Designer', salary: 70000, headcount: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'design' },
       { id: 'growth-hacker', name: 'Growth Hacker', salary: 65000, headcount: [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1], category: 'operations' },
    ],
    operatingCosts: [
       { id: 'cloud-hosting', name: 'Cloud Hosting & APIs', monthlyCosts: [200,250,300,350,400,450,500,550,600,650,700,750,800,850,900,950,1000,1050,1100,1150,1200,1250], category: 'infrastructure' },
       { id: 'design-tools', name: 'Design Tools', monthlyCosts: [150,175,200,225,250,275,300,325,350,375,400,425,450,475,500,525,550,575,600,625,650,675], category: 'tools' },
       { id: 'marketing-tools', name: 'Marketing & Analytics Tools', monthlyCosts: [300,350,400,450,500,550,600,650,700,750,800,850,900,950,1000,1050,1100,1150,1200,1250,1300,1350], category: 'marketing' },
       { id: 'coworking', name: 'Co-working Space', monthlyCosts: [400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400,400], category: 'facilities' },
    ],
    companyProfile: {
      name: 'LeanProduct Co',
      industry: 'Product',
      location: 'Portland, OR',
      companySize: 'small',
      salaryMultiplier: 0.85,
    },
    assumptions: {
      initialUsers: 100,
      monthlyGrowthRate: 25, // Higher growth for product-led
      revenueMultiple: 10,
      soloGrowthRate: 20,
      teamGrowthRate: 22,
      unlimitedGrowthRate: 25,
      enableExpenseGrowth: true,
      expenseGrowthRate: 15,
      expenseGrowthCap: 70,
    },
    pricing: {
      soloPrice: 19,
      teamPrice: 59,
      unlimitedPrice: 199,
    },
  },
];